export const INSTITUTION_LISTING_CONFIG = {
  basePath: "/institutions",
  pageSize: 10,
  staleTimeMs: 120_000,
  gcTimeMs: 600_000,
} as const;
